// extracted by mini-css-extract-plugin
module.exports = {"banner":"App_banner__2DfoT","title":"App_title__16Zdb","link":"App_link__2kEme","explore":"App_explore__1J1M3"};